import { useState, useEffect } from 'react'
import { formatPeriod } from '@/utils/index'

function useGuaranteeOptions (duration, period) {
  const [options, setOptions] = useState([])
  const [loading, setLoading] = useState(true) // Initialize loading state

  // Constants for time unit conversions
  const DAYS_IN_YEAR = 365 // Approximation, ignoring leap years
  const DAYS_IN_MONTH = 30 // Approximation, assuming 30 days per month

  // Function to convert duration to days based on the period
  const convertDurationToDays = (duration, period) => {
    switch (period) {
      case 'years':
        return duration * DAYS_IN_YEAR
      case 'months':
        return duration * DAYS_IN_MONTH
      case 'days':
        return duration
      default:
        console.log('Invalid period')
    }
  }

  useEffect(() => {
    setLoading(true) // Start loading
    try {
      const durationInDays = convertDurationToDays(duration, period)
      const showBreederGuarantee = durationInDays > 20

      const selectedOptions = [
        {
          id: 1,
          title: '14-Day Health Guarantee - Free, Included',
          description: 'This guarantee covers infectious diseases, life-threatening illnesses, and hereditary disorders.',
          icon: 'health-guarantee.svg'
        }
      ]

      if (showBreederGuarantee) {
        selectedOptions.push({
          id: 2,
          title: `${duration} - ${formatPeriod(duration, period)} Genetic Health Guarantee - Free, Included`,
          description: 'This extended guarantee covers hereditary or congenital disorders.',
          icon: 'genetic-health-guarantee.svg'
        })
      }

      setOptions(selectedOptions)
    } catch (error) {
      console.error(error.message)
      setOptions([])
    } finally {
      setLoading(false) // End loading
    }
  }, [duration, period])

  return { options, loading } // Return both options and loading state
}

export default useGuaranteeOptions
